import { Choices } from "@saleor/components/SingleSelectField";
import { ChangeOrderStatusEnum } from "@saleor/graphql";

export enum FIELD_TYPE {
  SINGLE_INPUT = "SINGLE_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  SUGGESTION_INPUT = "SUGGESTION_INPUT",
  RADIO_GROUP = "RADIO_GROUP",
  DATEPICKER = "DATEPICKER",
  MULTIPLE_SELECT = "MULTIPLE_SELECT"
}

export interface FORM_DATA {
  title: string;
  name: string;
  type: string;
  placeholder?: string;
  options?: Choices;
  maxLength?: number;
  defaultValue?: string;
}

export const orderTypeChoices = [
  { label: "All", value: ChangeOrderStatusEnum.ALL },
  { label: "Complete", value: ChangeOrderStatusEnum.COMPLETE },
  { label: "Open", value: ChangeOrderStatusEnum.OPEN }
];

export interface SubmitFilterDataType {
  soldTo?: string;
  materialCodeName?: string;
  soNo?: string;
  poNo?: string;
  purchaseOrderNo?: string;
  contractNo?: string;
  saleGroup?: string;
  bu?: string;
  company?: string;
  statusSap?: ChangeOrderStatusEnum;
  saleEmployee?: string;
  orderType?: string;
  invoiceNo?: string;
  dpNo?: string;
  materialGroup1?: string;
  sourceOfApp?: string;
  dateSelectionType?: DateSelectionType;
  createDate?: {
    gte: string;
    lte: string;
  };
  lastUpdate?: {
    gte: string;
    lte: string;
  };
}

export enum DateSelectionType {
  CREATE_DATE = "CREATE_DATE",
  LAST_UPDATE = "LAST_UPDATE"
}
